import { render, staticRenderFns } from "./scrolltable.vue?vue&type=template&id=030f4128&scoped=true"
import script from "./scrolltable.vue?vue&type=script&lang=ts"
export * from "./scrolltable.vue?vue&type=script&lang=ts"
import style0 from "./scrolltable.vue?vue&type=style&index=0&id=030f4128&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030f4128",
  null
  
)

export default component.exports